import {
  orderBy,
  documentId,
  where,
  startAfter,
  endBefore,
  limit,
  startAt,
  endAt,
  limitToLast,
  query,
  getDocs,
} from 'firebase/firestore/lite'

const getAllRaw = async (props = {}, getCollection, softDeletable = true) => {
  const { keyword, pageInfo = {}, where: wheres = [], order } = props
  const { limit: pageLimit, action, firstItem, lastItem } = pageInfo
  let c = getCollection()

  if (softDeletable) {
    c = query(c, where('deletedAt', '==', null))
  }

  if (order) {
    c = query(c, orderBy(...order))
  } else if (keyword) {
    console.log(keyword)
    c = query(c, orderBy('search', 'asc'))
    c = query(c, startAt(keyword.toLowerCase()))
    c = query(c, endAt(keyword.toLowerCase() + '\uf8ff'))
  } else {
    if (keyword) {
      c = query(c, where('search', '>=', keyword))
      c = query(c, where('search', '<=', keyword + '~'))
      c = query(c, orderBy('search', 'asc'))
    } else {
      c = query(c, orderBy(documentId(), 'asc'))
    }
  }

  if (limit) {
    c = query(c, limit(pageLimit + 1))
    if (action && action !== 0) {
      c = query(c, action > 0 ? startAfter(lastItem.id) : endAt(firstItem.id))
    }
  }

  if (wheres.length > 0) {
    wheres.map((w) => {
      return (c = query(c, where(...w)))
    })
  }

  return getDocs(c)
}

export default getAllRaw
